import React, { useEffect, useRef, useState } from "react";
import "./Footer.css";
import { useNavigate, Link } from "react-router-dom";
const Footer = () => {
  const navigate = useNavigate();
  const footerRef = useRef();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    if (footerRef.current) {
      observer.observe(footerRef.current);
    }

    return () => {
      if (footerRef.current) {
        observer.unobserve(footerRef.current);
      }
    };
  }, []);

  return (
    <footer ref={footerRef} className="footer">
      <div className="container footer-container">

        <div className={`footer-col ${visible ? "show" : ""}`}>
          <h3>QuickSeva</h3>
          <p>
            Har Ghar Ki Seva
          </p>
          <p className="mb-5">
            Our services are 100% guaranteed with the customer satisfaction
          </p>
          <a
            href="https://wa.me/917661045308?text=Hello%20I%20want%20to%20book%20a%20service"
            className="text-dark mx-3"
            target="_blank"
            rel="noopener noreferrer"
          >
            <i className="bi bi-whatsapp"></i>
          </a>
          <a href="" className="text-dark mx-3 "><i class="bi bi-instagram"></i></a>
          <a href="" className="text-dark mx-3 "><i class="bi bi-twitter-x"></i></a>
          <a href="" className="text-dark mx-3 "><i class="bi bi-google"></i></a>
        </div>

        <div className={`footer-col ${visible ? "show delay1" : ""}`}>
          <h4>Quick Links</h4>
          <ul className="list-unstyled">

            <li>
              <i className="bi bi-arrow-right-short mx-2"></i>
              <Link to="/" className="text-decoration-none text-dark">Home</Link>
            </li>

            <li>
              <i className="bi bi-arrow-right-short mx-2"></i>
              <Link to="/" className="text-decoration-none text-dark">About Us</Link>
            </li>

            <li>
              <i className="bi bi-arrow-right-short mx-2"></i>
              <Link to="/electrician" className="text-decoration-none text-dark">Services</Link>
            </li>

            <li>
              <i className="bi bi-arrow-right-short mx-2"></i>
              <Link to="/" className="text-decoration-none text-dark">Why We</Link>
            </li>

            <li>
              <i className="bi bi-arrow-right-short mx-2"></i>
              <Link to="/" className="text-decoration-none text-dark">FAQ</Link>
            </li>

          </ul>
        </div>

        <div className={`footer-col ${visible ? "show delay2" : ""}`}>
          <h4>Our Services</h4>
          <ul>
            <li><i class="bi bi-arrow-right-short mx-2"></i>Electrician</li>
            <li><i class="bi bi-arrow-right-short mx-2"></i>Plumber</li>
            <li><i class="bi bi-arrow-right-short mx-2"></i>AC Technician</li>
            <li><i class="bi bi-arrow-right-short mx-2"></i>Fridge Repairs</li>
            <li><i class="bi bi-arrow-right-short mx-2"></i>Carpenter</li>
            <li><i class="bi bi-arrow-right-short mx-2"></i>Washing Machine Services</li>
          </ul>
        </div>

        <div className={`footer-col ${visible ? "show delay3" : ""}`}>
          <h4>Get In Touch</h4>
          <p>Hyderabad, Telangana</p>
          <p>+91 7661045308</p>
          <p>coolairconditioners27@gmail.com</p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
